module.exports = __webpack_public_path__ + "static/img/4.c3a6624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/1/4.png
// module id = U563
// module chunks = 1